// extracted by mini-css-extract-plugin
export default {"points":"Price_points--xMb"};